import React from "react";
import VideoTile from "./VideoTIle";
import "../JoinScheduledEvent.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faArrowCircleDown,
  faArrowCircleUp,
  faMicrophone,
  faMicrophoneSlash,
  faMinusCircle,
  faPlane,
  faPlaneUp,
  faStopCircle,
  faVideo,
  faVideoSlash,
} from "@fortawesome/free-solid-svg-icons";
import { timeToLocalString } from "../../../../_helpers/dateFormatter";
import StarRatings from "react-star-ratings";
import ScreenShareTile from "./ScreenShareTile";

function JoinedScreen({
  peers,
  user,
  hmsRoomDetail,

  screenShareOn,
  presenter,
  localScreenShared,
  screenShareVideoTrack,

  hmsRoomQuestions,
  handleModalOpen,
  toggleAudioClick,
  toggleVideoClick,
  isLocalAudioEnabled,
  isLocalVideoEnabled,
  onShowMessagesClick,
  showMessages,
  brodacastMessages,
  sendBroadCastMessage,
  messageForm,
  onMessageFormChange,
  onCallEndClick,
  onQuestionRatingChange,

  onScreenShareClick,
  onDeleteHmsQuestion,
  onEditQuestionClick,
  joineesNames
}) {
  return (
    <div className="meeting-main-wrapper">
      <p className="joined-indicator">
        <h3 className="mb-2 text-wrap">
          {joineesNames[0]}{" "} meet with {" "}
          {joineesNames[1]}{" "}
        </h3>
      </p>
      <div className="meeting-layout d-flex">
        <div className={` ${screenShareOn ? "d-block" : "d-flex w-100"}`}>
          {peers &&
            Array.isArray(peers) &&
            peers.map((peer) => {
              return <VideoTile peer={peer} screenShareOn={screenShareOn} />;
            })}
        </div>
        {screenShareOn ? (
          <ScreenShareTile
            presenter={presenter}
            screenShareVideoTrack={screenShareVideoTrack}
            localScreenShared={localScreenShared}
          />
        ) : null}
      </div>

      {/* mentor skills */}
      {user?.role === "mentor" &&
        hmsRoomDetail?.candidate_job_application !== null ? (
        <ul className="bg-white border p-3 form-group question-box rounded-lg">
          {hmsRoomQuestions &&
            Array.isArray(hmsRoomQuestions) &&
            hmsRoomQuestions.map((item, index) => (
              <li className="py-2 border-bottom d-flex align-items-start w-100">
                <span className="mr-2">{index + 1}.</span>
                <div className="flex-grow-1">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="font-weight-medium mb-0">{item?.question}</p>
                    <div className="d-flex align-items-center">
                      <img src="/assets/images/edit.svg" className="cursor-pointer mr-1" onClick={() => onEditQuestionClick(item)}
                        alt="" />
                      <FontAwesomeIcon icon={faMinusCircle} className="cursor-pointer text-danger" onClick={() => onDeleteHmsQuestion(item?.id)} />
                    </div>
                  </div>
                  <p className="text-primary font-weight-medium text-capitalize mt-2">
                    {item?.skill_tag && item.skill_tag[0]}
                  </p>
                  <StarRatings
                    rating={item?.rating === null ? 0 : item?.rating}
                    starRatedColor="#ffc400"
                    changeRating={(e) => onQuestionRatingChange(e, item)}
                    numberOfStars={5}
                    name="rating"
                    starDimension="24"
                    starHoverColor="#FCDDB0"
                  />
                </div>
              </li>
            ))}
          <button
            className="text-primary btn border-0 py-1 mt-3"
            onClick={handleModalOpen}
          >
            + Add Question
          </button>
        </ul>
      ) : null}

      <div className="actions-section d-flex align-items-center justify-content-center">
        <button className=" mr-3 action-btn" onClick={toggleAudioClick}>
          {isLocalAudioEnabled ? (
            <FontAwesomeIcon icon={faMicrophone} />
          ) : (
            <FontAwesomeIcon icon={faMicrophoneSlash} />
          )}
        </button>
        <button className="action-btn mr-3" onClick={toggleVideoClick}>
          {isLocalVideoEnabled ? (
            <FontAwesomeIcon icon={faVideo} />
          ) : (
            <FontAwesomeIcon icon={faVideoSlash} />
          )}
        </button>
        <button className="action-btn mr-3" onClick={onScreenShareClick}>
          {localScreenShared ? (
            <FontAwesomeIcon icon={faArrowCircleDown} />
          ) : (
            <FontAwesomeIcon icon={faArrowCircleUp} />
          )}
        </button>
        <button className="d-flex btn p-0 " onClick={onCallEndClick}>
          <img src="/assets/images/end-call.svg" alt="call-end" style={{ height: "50px", width: "50px" }} />
        </button>
      </div>
      <div className={`message-panel border-radius-10 ${showMessages ? "shadow-sm bg-white border " : "text-right"}`} >
        <div className={`d-flex align-items-center px-3 ${showMessages ? "justify-content-between border-bottom " : "justify-content-end"}`}>
          {showMessages && <h4>In-call Messages</h4>}
          <button
            className="btn bg-transparent border-0 px-0"
            onClick={onShowMessagesClick}
          >
            <span className="font-weight-bold text-right">
              {" "}
              <img src="/assets/images/chat.svg" alt="chat" />
            </span>
          </button>
        </div>
        {showMessages ? (
          <div className="broadcasted-messages bg-white">
            <div className="broadcasted-messages-list mt-3">
              {brodacastMessages &&
                Array.isArray(brodacastMessages) &&
                brodacastMessages.map((item) => (
                  <div className={`mb-3 w-75 ${item?.senderName === user?.user && user.user?.full_name ? "ml-auto" :""}`}>
                    <h5 className="d-flex align-items-center d-flex justify-content-between mb-2 text-capitalize">
                      <span className="text-grey-4 ml-2 font-weight-normal ">
                        {item?.time && timeToLocalString(item?.time)}
                      </span>
                    </h5>

                    <p className={`fs-smallest mb-0 border p-2 text-wrap ${item?.senderName ? "others-msg bg-grey" : "your-msg bg-dark text-white"}`}>
                      {item?.message}
                    </p>
                  </div>
                ))}
            </div>

            <form onSubmit={sendBroadCastMessage}>
              <div className="form-wrapper bg-white border-top p-3 d-flex">
                <input
                  type="text"
                  className="form-control flex-grow-1 h-auto py-2 border-radius-10"
                  placeholder="Send a message"
                  name="msg"
                  autoComplete="off"
                  value={messageForm}
                  onChange={onMessageFormChange}
                />
                <button className="btn btn-primary ml-2 py-2 border-radius-10 text-white">
                  <img src="/assets/images/send-light.svg" alt="" className="align-middle" />
                </button>
              </div>
            </form>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default JoinedScreen;
